/* eslint-disable @typescript-eslint/naming-convention */
import type { Theme, PartialTheme } from './Theme';

/**
 * {@docCategory ITheme}
 */
export interface ITheme extends Theme {}

/**
 * {@docCategory ITheme}
 */
export interface IPartialTheme extends PartialTheme {}

export type { ISchemeNames, IScheme } from './IScheme';
